export { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE } from './constants';
